// import $public from '../../util/public.js'
export default {
	namespaced: true,
	state: {
		changeNum:1,
		yaoyueNum:1,
		suodingNum:1,
		xiaoxiNum:1,
		huifangNum:1
	},
	getters: {
		
	},
	mutations: {
		set_changeNum(state) {
			state.changeNum++;
		},
		set_yaoyueNum(state) {
			state.yaoyueNum++;
		},
		set_suodingNum(state) {
			state.suodingNum++;
		},
		set_xiaoxiNum(state) {
			state.xiaoxiNum++;
		},
		set_huifangNum(state) {
			state.huifangNum++;
		},
	},
	actions: {

	},
};
